import { css } from 'styled-components'
import { BREAKPOINTS, COLORS } from '~/shared/constants/uiConstants'

export const anatomyV2RootCss = css`
  width: 100%;
  height: calc(100dvh - var(--header-height));
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${COLORS.GRAY_100};
`

export const anatomyV2ContentWrapperCss = css`
  max-width: ${BREAKPOINTS[375]}px;
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
`
